import BasicDetails from "./basicDetails";
import Ingredients from "./ingredients";
import Categories from "./categories";
import Sources from "./sources";
import Images from "./images";

export const recipeSteps = [
	{
		id: "basicDetails",
		title: "Basic Details",
		component: BasicDetails
	},
	{
		id: "ingredients",
		title: "Ingredients",
		component: Ingredients
	},
	{
		id: "categories",
		title: "Categories",
		component: Categories
	},
	{
		id: "sources",
		title: "Sources",
		component: Sources
	},
	{
		id: "images",
		title: "Images",
		component: Images
	}
];
